import {Component, Input} from '@angular/core';
import {TileType41} from "../../../models";
import {
    ControlService,
    ParametersService,
    SubtitlesService,
} from "../../../core";
import {StateService} from "@uirouter/core";

@Component({
    selector: 'tile-date',
    templateUrl: './tile-date.component.html',
    styleUrls: ['./tile-date.component.scss']
})
export class TileDateComponent {
    @Input() tile: TileType41;

    constructor(
        private control: ControlService,
        private parameters: ParametersService,
        private $state: StateService,
        public subtitles: SubtitlesService,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    goControl() {
        if (this.tile.elementMenu) {
            this.$state.go('control', {
                selectedModuleHash: this.parameters.selectedModuleHash
            });
            this.control.setControl(this.tile.elementMenu);
        }
    }

    getIconName() {
        return this.parameters.urlCompany === 'klimor' ? 'setting-klimor': 'setting'
    }
}
